import checkBankStatus from '../../../../api/bank/checkStatusAppeal';
import Button from '../../../../components/Button/Button';
import FormHeading from '../../../../components/Typography/FormHeading';
import Hint from '../../../../components/Hint';

const CheckBankStatus = ({ chunkId, bankId, setLoading = () => {}, onSuccess, text = 'Обновить', hint }) => {
  const onCheckBankStatus = async () => {
    try {
      setLoading(true);
      await checkBankStatus({ chunkId, bankId });
      onSuccess && onSuccess();
    } finally {
      setLoading(false);
    }
  };

  if (!hint) return <Button onClick={onCheckBankStatus} text={text} fill />;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button onClick={onCheckBankStatus} text={text} fill />
      <Hint text={hint} />
    </div>
  );
};

export default CheckBankStatus;
